import React from 'react'
import { styled, useTheme } from 'src/ui/theme'
import { HBox, Wrapper } from 'src/ui/layout'
import { Label, Header, Body } from 'src/ui/typography'
import { Image } from 'src/ui/atoms'

const StyledWrapper = styled(Wrapper)`
  background-color: ${({ theme }) => theme.colors.gray.bg};
`

const StyledLabel = styled(Label)`
  text-transform: uppercase;
  font-weight: 700;
`

const StatsBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`

const StatsItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`

type Props = {
  images: TImages
}

export const Podcast = ({ images }: Props) => {
  const theme = useTheme()
  return (
    <StyledWrapper>
      <HBox height={48} />
      <StyledLabel>качаем софтскиллы вместе с подкастом KODE</StyledLabel>

      <HBox height={8} />
      <Header as="h4" size="h4">
        «Вдруг тут что-то важное»
      </Header>

      <HBox height={8} />
      <Body>
        В 2024 году мы запустили подкаст о том, как строить и развивать карьеру
        в IT. Мы хотели создать полезный, доступный и вдохновляющий продукт для
        всех русскоговорящих  IT-специалистов. Нам было важно не просто
        рассказывать истории топов бигтеха, а создать среду для обмена опытом,
        который каждый слушатель может применить в реальной жизни.
        <br /> <br />
        За 3 сезона подкаста к нам пришли технические директора, продуктовые
        менеджеры и архитекторы из топовых компаний России — Авито, ТБанк,
        Skillbox, и другие
      </Body>

      <HBox height={24} />

      <StatsBlock>
        <StatsItem>
          <Header size="h3" as="h3" color={theme.colors.brand.primary}>
            1500+
          </Header>
          <Label>подписчиков</Label>
        </StatsItem>
        <StatsItem>
          <Header size="h3" as="h3" color={theme.colors.brand.primary}>
            10000+
          </Header>
          <Label>прослушиваний</Label>
        </StatsItem>
      </StatsBlock>

      <HBox height={32} />

      <Body weight="medium">
        <a href="https://kode.mave.digital/" target="_blank">
          Слушать подкаст по ссылке →
        </a>
      </Body>

      <HBox height={32} />

      <Image fluid={images['podcast']} />

      <HBox />
    </StyledWrapper>
  )
}
